import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  alpha,
  Box,
  Card,
  CardContent,
  Container,
  Typography,
} from "@mui/material";
import theme, { responsiveFontSize } from "themes/Theme";
import AccordionUpIcon from "assets/svg/AccordionUpIcon";
import { useEffect, useState } from "react";
import { HomeBg } from "assets/index";
import { FaqData } from "meta/faq";

const FAQPage = () => {
  const [expanded, setExpanded] = useState("panel1");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (panel: any) => (_event: any, newExpanded: any) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.pageHeroBg}>
        <center>
          <Typography sx={styles.pageTitle}>
            Frequently Asked
            <br />
            Questions
          </Typography>
        </center>
      </Box>
      <Container sx={{ py: 4 }}>
        <Card sx={styles.cardContainer}>
          <CardContent>
            {FaqData.map((item, index) => (
              <Accordion
                expanded={expanded === `panel${index + 1}`}
                onChange={handleChange(`panel${index + 1}`)}
                disableGutters
                elevation={0}
                key={index}
                sx={{
                  boxShadow: "none",
                  border: "none",
                  borderRadius: "8px",
                  overflow: "hidden",
                  backgroundColor:
                    expanded === `panel${index + 1}`
                      ? alpha(theme.palette.primary.light, 0.2)
                      : "transparent",
                }}
              >
                <AccordionSummary
                  aria-controls="panel1d-content"
                  id="panel1d-header"
                  expandIcon={<AccordionUpIcon />}
                >
                  <Typography sx={styles.accordionTitleText}>
                    {item.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={styles.accordionDescriptionText}>
                    {item.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};
export default FAQPage;
const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: theme.palette.secondary.main,
  },
  pageHeroBg: {
    backgroundImage: `url(${HomeBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    borderBottomLeftRadius: "50px",
    borderBottomRightRadius: "50px",
    width: "100%",
    padding: "1em",
  },
  pageTitle: {
    py: 15,
    fontSize: responsiveFontSize(75),
    fontWeight: 400,
    color: theme.palette.custom.white,
  },
  cardContainer: {
    flex: 1,
    borderRadius: "2.5em",
    boxShadow:
      "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
    backgroundColor: "#FFFFFF",
    marginTop: "2em",
  },
  accordionTitleText: {
    fontSize: responsiveFontSize(14),
    color: theme.palette.text.primary,
    fontWeight: 400,
  },
  accordionDescriptionText: {
    fontSize: responsiveFontSize(12),
    color: theme.palette.text.secondary,
    fontWeight: 400,
  },
};
